export const config = {
  API_ENDPOINT: process.env.API_ENDPOINT,
};
